import { BLOCKS, MARKS } from '@contentful/rich-text-types';
import { Container, Row, Col } from '@everlywell/leaves';
import SectionWrapper from 'components/SectionWrapper';
import {
  renderRichText,
  RenderRichTextData,
} from 'gatsby-source-contentful/rich-text';
import React, { ReactNode } from 'react';

import * as S from './styles';

interface Props {
  backgroundColor: string;
  slug: string;
  richText: RenderRichTextData<any>;
}

const options: any = {
  renderText: (text: string) =>
    text
      .split('\n')
      .reduce(
        (children: ReactNode[], textSegment, index) => [
          ...children,
          index > 0 && <br key={index} />,
          textSegment,
        ],
        [],
      ),
  renderMark: {
    [MARKS.BOLD]: (text: string) => <S.Bold>{text}</S.Bold>,
    [MARKS.UNDERLINE]: (text: string) => <S.Underline>{text}</S.Underline>,
  },
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node: any, children: ReactNode) => (
      <S.Paragraph>{children}</S.Paragraph>
    ),
    [BLOCKS.OL_LIST]: (node: any, children: ReactNode) => <ol>{children}</ol>,
    [BLOCKS.UL_LIST]: (node: any, children: ReactNode) => <ul>{children}</ul>,
    [BLOCKS.LIST_ITEM]: (node: any, children: ReactNode) => (
      <S.ListItem>{children}</S.ListItem>
    ),
  },
};

export const RichTextSection: React.FC<Props> = ({
  richText,
  slug,
  backgroundColor,
}: Props) => (
  <SectionWrapper
    data-testid={slug || 'richTextSection'}
    id={slug}
    backgroundColor={backgroundColor}
  >
    <Container>
      <Row>
        <Col xs>
          <S.Wrapper>{renderRichText(richText, options)}</S.Wrapper>
        </Col>
      </Row>
    </Container>
  </SectionWrapper>
);

export default RichTextSection;
